<template>
  <nav class="header">
    <div class="live-header">
      <div class="header-left-box">
        <p class="title">丽水市新闻传媒中心（传媒集团）直播</p>
      </div>
      <div class="header-right-box">
        <div v-if="!token" class="login">
          <p class="pc-wx-login" @click="dialogLoginVisible = true">登录</p>
        </div>
        <div v-else class="user">
          <el-dropdown
            ref="navDropdown"
            trigger="click"
            style="margin-right: 30px"
            @command="navCommand"
          >
            <div class="user">
              <div class="head">
                <img
                  class="img"
                  :src="
                    userInfo.thumb
                      ? `${
                          userInfo.thumb
                        }?x-oss-process=image/resize,w_60&time=${new Date().getTime()}`
                      : `${logo60}?time=${new Date().getTime()}`
                  "
                  alt=""
                />
              </div>
              <span class="name">{{ userInfo.fullName }}</span>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogLoginVisible"
      width="40%"
      center
      :show-close="false"
    >
      <login-content></login-content>
    </el-dialog>
  </nav>
</template>

<script>
  import { mapGetters } from 'vuex';
  import LoginContent from '@/components/login';
  export default {
    name: 'navHeader',
    components: {
      LoginContent,
    },
    props: {
      msg: String,
    },
    data() {
      return {
        dialogLoginVisible: false,
        logo60: require('../../static/images/60x60.png'),
      };
    },
    computed: {
      ...mapGetters(['token', 'userInfo']),
    },
    methods: {
      navCommand(command) {
        if (command === 'logout') {
          this.logout();
        }
      },
      logout() {
        this.$confirm('确定是否退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$store.dispatch('user/logout');
          })
          .catch(() => {});
      },
      openLogin() {
        this.dialogLoginVisible = true;
      },
      closeLogin() {
        this.dialogLoginVisible = false;
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .header {
    background: rgba(42, 42, 46, 0.7);
    height: 60px;
    color: #fff;
  }
  .live-header {
    width: calc(100% - 44px);
    height: 100%;
    padding: 0 22px;
    display: flex;
    align-items: center;
  }
  .header-left-box {
    flex: 1;
  }
  .header-right-box {
    flex: 0 0 auto;
  }
  .login {
    width: 104px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 36px;
    font-size: 14px;
    cursor: pointer;
    color: #000;
    p {
      font-size: 18px;
      color: #fff;
    }
  }
  .title {
    vertical-align: middle;
    font-size: 17px;
    color: #fff;
  }
  .user {
    cursor: pointer;
    display: flex;
    align-items: center;
    .head {
      vertical-align: middle;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      overflow: hidden;
      .img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .name {
      vertical-align: middle;
      margin-left: 11px;
      font-size: 18px;
      color: #fff;
    }
  }

  /deep/ .el-dropdown-menu__item {
    min-width: 56px;
  }
  /deep/ .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    color: #606266;
  }

  /deep/ .el-dialog {
    min-width: 400px;
    max-width: 500px;
    border-radius: 12px;
  }
</style>
